// extracted by mini-css-extract-plugin
export default {"branding":"branding__3Hjip","link":"link__6awIl","readonly":"readonly__50HIy","logo":"logo__EdbVR"};